import { BooleanField, ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import useDiagramTreeModal from '@/pages/Candidate/hooks/useDiagramTreeModal';
import { CriminalVersionField } from '@/pages/Candidate/view/fields';
import DecisionTreeModal from '@/pages/Candidate/view/modals/DecisionTreeModal';
import { CheckRecordActiveSwitch } from '@/pages/Candidate/view/utils';
import { MainDatagridStyled } from '@/styles/overrides';
import { FCRAWorkerCheckRecordTypeEnum, TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { path } from './constants';

const SexOffenderRecordsTab = (props: Partial<TabProps>) => {
  const { diagramTreeData, handleCloseDiagramTree, handleOpenDiagramTree, isDiagramTreeOpen } = useDiagramTreeModal();

  return (
    <Tab label="SexOffender" {...props}>
      <DecisionTreeModal data={diagramTreeData} isOpen={isDiagramTreeOpen} onCloseButton={handleCloseDiagramTree} />
      <ReferenceManyField
        label=""
        reference={TurnReferencesEnum.Candidates}
        target={TurnTargetsEnum.WorkerSexOffenderRecords}
      >
        <MainDatagridStyled bulkActionButtons={false} rowClick={false} sx={{ width: 'max-content' }}>
          <CheckRecordActiveSwitch type={FCRAWorkerCheckRecordTypeEnum.SexOffender} />
          <TextField emptyText="false" sortable={false} source={path('active')} />
          <BooleanField label="Records Match" source={path('records_match')} />
          <BooleanField label="Turn Match" source={path('turn_match')} />
          <CriminalVersionField
            label="Criminal Version"
            onClick={handleOpenDiagramTree}
            sortable={false}
            source={path('criminal_version')}
          />
          <TextField label="Create TS" source={path('create_ts')} />
          <TextField label="ID" source={path('id')} />
          <TextField label="Recheck ID" source={path('recheck_id')} />
          <TextField label="Report Token" sortable={false} source={path('report_token')} />
          <TextField label="Case Number" source={path('case_number')} />
          <TextField label="State" source={path('state')} />
          <TextField label="County" source={path('county')} />
          <TextField label="Crime Type" source={path('crime_type')} />
          <TextField label="Offense Description" source={path('offense_description1')} />
          <TextField label="Disposition" source={path('disposition')} />
          <TextField label="Disposition Date" source={path('disposition_date')} />
          <TextField label="Offense Date" source={path('offense_date')} />
          <TextField label="Address Match" source={path('address_match')} />
          <TextField label="Date of Birth Match" source={path('date_of_birth_match')} />
          <TextField label="First Name Match" source={path('first_name_match')} />
          <TextField label="Last Name Match" source={path('last_name_match')} />
          <TextField label="Middle Name Match" source={path('middle_name_match')} />
          <TextField label="SSN Match" source={path('ssn_match')} />
          <TextField label="Gender Match" source={path('gender_match')} />
          <TextField label="Name Match" source={path('name_match')} />
          <TextField label="Race Match" source={path('race_match')} />
          <TextField label="Suspect First Name" sortable={false} source={path('suspect_first_name')} />
          <TextField label="Suspect Last Name" sortable={false} source={path('suspect_last_name')} />
          <TextField label="Suspect Middle Name" sortable={false} source={path('suspect_middle_name')} />
          <TextField label="Record Type" sortable={false} source={path('record_type')} />
          <TextField label="DOB" sortable={false} source={path('dob')} />
          <TextField label="FIPS" source={path('fips')} />
        </MainDatagridStyled>
      </ReferenceManyField>
    </Tab>
  );
};

export default SexOffenderRecordsTab;
